<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6">
    <!-- Primary contact -->
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Disclosures & Billing Information
        </h3>
        <p class="mt-1 text-sm text-gray-500"></p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
              <h4 class="text-lg font-bold">Disclosures</h4>
              <div class="-mx-3 md:flex mb-2 mt-2">
                <div class="md:w-1/2 px-3 mb-2 md:mb-0">
                  <label
                    class="block text-sm font-medium text-gray-900"
                    for="firstname"
                  >
                    Have any complaints been filed against you with any
                    disciplinary authority within the last five(5) years?
                    <span class="text-red-500">*</span>
                  </label>
                  <label
                    v-for="item in flag_options"
                    :key="item.id"
                    class="inline-flex items-center mt-3 ml-2"
                  >
                    <input
                      type="radio"
                      :value="item.id"
                      v-model="form.have_complaint"
                      class="form-radio h-5 w-5 cobalt-text-color"
                    /><span class="ml-2 text-black-100">{{ item.name }}</span>
                  </label>
                  <div
                    class="text-red-600 mt-1 text-sm"
                    v-for="(error, index) in v$.form.have_complaint.$errors"
                    :key="index"
                  >
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                </div>
                <div class="md:w-1/2 px-3 mb-2 md:mb-0">
                  <label
                    class="block text-sm font-medium text-gray-900"
                    for="complaint_detail"
                  >
                    If your answer is “Yes”, please list the disciplinary
                    authority, the nature and date of the complaint and the
                    outcome.
                    <span class="text-red-500" v-if="form.have_complaint == 1"
                      >*</span
                    >
                  </label>
                  <textarea
                    class="w-full text-black border-1 border-barley rounded py-2 px-4 "
                    id="complaint_detail"
                    v-model="form.complaint_detail"
                  ></textarea>
                  <div
                    class="text-red-600 mt-1 text-sm"
                    v-for="(error, index) in v$.form.complaint_detail.$errors"
                    :key="index"
                  >
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                </div>
              </div>
               <div class="-mx-3 md:flex mb-2 mt-2">
               <div class="md:w-1/2 px-3 mb-2 md:mb-0">
                  <label
                    class="block text-sm font-medium text-gray-900"
                    for="complaint_detail"
                  >
                    Note (Message)
                  </label>
                  <textarea
                    class="w-full text-black border-1 border-barley rounded py-2 px-4 "
                    id="note"
                    v-model="form.note"
                  ></textarea>
                </div>
              </div>
              <!-- full section for FAM and CDL -->
              <div>
                <h4 class="text-lg font-bold">Billing Information</h4>
                <div class="-mx-3 md:flex mb-2">
                  <div class="md:w-1/2 px-3 py-2">
                    <!-- <label
                          class="block text-sm font-medium text-gray-900 mt-2"
                          for="type"
                          >Number Type <span class="text-red-500">*</span>
                        </label> -->
                    <label
                      v-for="item in number_options"
                      :key="item.id"
                      class="inline-flex items-center mt-3 ml-2"
                    >
                      <input
                        type="radio"
                        v-model="form.number_type"
                        :value="item.id"
                        class="form-radio h-5 w-5 cobalt-text-color"
                      /><span class="ml-2 text-black-100">{{ item.name }}</span>
                    </label>
                  </div>
                  <div
                    class="md:w-1/2 px-3 py-2"
                    v-if="form.number_type === 'ssn'"
                  >
                    <label class="block text-sm font-medium text-gray-900">
                      Social Security Number<span class="text-red-500">*</span>
                    </label>

                    <div class="relative">
                      <!-- View Mode -->
                      <div v-if="!isEditing" key="view-mode" class="relative">
                        <input
                          type="text"
                          :value="maskedSSN"
                          readonly
                          tabindex="-1"
                          class="mt-1 block h-10 w-full border border-gray-300 bg-gray-100 rounded-sm shadow-sm py-2 px-3 pr-12 text-gray-700 sm:text-sm"
                        />
                        <button
                          type="button"
                          @click="isEditing = true"
                          class="absolute right-3 top-2.5 text-indigo-600 text-sm hover:underline focus:outline-none"
                        >
                          Edit
                        </button>
                      </div>

                      <!-- Edit Mode -->
                      <div v-else key="edit-mode" class="relative">
                        <InputMask
                          :mask="'999-99-9999'"
                          v-model="form.ssn_number"
                          :required="true"
                          :class="{ 'border-red-400': v$.form.ssn_number.$error }"
                          class="mt-1 block h-10 w-full border border-gray-300 rounded-sm shadow-sm py-2 px-3 pr-12 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <button
                          type="button"
                          @click="isEditing = false"
                          class="absolute right-3 top-2.5 text-gray-500 text-sm hover:underline focus:outline-none"
                        >
                          Cancel
                        </button>

                        <!-- Error Message in edit mode only -->
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.ssn_number.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator === 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="md:w-1/2 px-3 py-2"
                    v-if="form.number_type == 'ein'"
                  >
                    <label class="block text-sm font-medium text-gray-900"
                      >EIN<span class="text-red-500">*</span></label
                    >
                    <InputMask
                      class="mt-1 h-10 block w-full border border-gray-300 rounded-sm shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      :class="{ 'border-red-400': v$.form.ssn_number.$error }"
                      v-model="form.ssn_number"
                      id="ssn_number"
                      mask="99-9999999"
                      :required="true"
                    />
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.ssn_number.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="-mx-3 md:flex mb-6"
                  v-if="
                    form.attorney_type.includes('FAM') ||
                      form.attorney_type.includes('CDL')
                  "
                >
                  <div class="md:w-1/2 px-3">
                    <text-input
                      label="Checks or Direct Deposit for services should be made payable to:"
                      :class="{ 'border-red-400': v$.form.pay_to.$error }"
                      v-bind:value="form.pay_to"
                      id="pay_to"
                      :required="true"
                      v-on:keyup="form.pay_to = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_to.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-3 xl:px-1 px-3 md:mt-0 mt-4">
                    <label class="block text-sm font-medium text-gray-900"
                      >Pay-To Address is same as the Primary Address?
                      <span class="text-red-500">*</span></label
                    >
                    <label
                      v-for="item in flag_options"
                      :key="item.id"
                      class="inline-flex items-center mt-3 ml-2"
                    >
                      <input
                        type="radio"
                        :value="item.id"
                        v-model="form.is_same_as_primary"
                        v-on:change="checkForAddress($event)"
                        class="form-radio h-5 w-5 cobalt-text-color"
                      /><span class="ml-2 text-black-100">{{ item.name }}</span>
                    </label>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.is_same_as_primary
                        .$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Pay To Address -->
                <div
                  class="grid xl:grid-cols-6 grid-cols-2 gap-6 mt-2"
                  v-if="
                    form.attorney_type.includes('FAM') ||
                      form.attorney_type.includes('CDL')
                  "
                >
                  <div class="col-span-6 sm:col-span-3">
                    <label
                      class="block text-sm font-medium text-gray-900"
                      for="pay_address_1"
                      >Pay-To Address Line 1 <span class="text-red-500">*</span>
                    </label>
                    <vue-google-autocomplete
                      v-if="mapsLoaded"
                      id="pay_address_1"
                      ref="pay_address_1"
                      v-model="form.pay_address_1"
                      :class="{
                        'border-red-400': v$.form.pay_address_1.$error,
                      }"
                      classname="w-full text-black border border-barley rounded-1 py-2 px-3 mt-1 mb-3"
                      v-on:placechanged="getAddressData($event, 'address1')"
                    >
                    </vue-google-autocomplete>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_address_1.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-3">
                    <text-input
                      label="Pay-To Address Line 2"
                      :class="{
                        'border-red-400': v$.form.pay_address_2.$error,
                      }"
                      v-bind:value="form.pay_address_2"
                      id="pay_address_2"
                      v-on:keyup="form.pay_address_2 = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_address_2.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="form-group grid grid-cols-6 gap-6 mt-2"
                  v-if="
                    form.attorney_type.includes('FAM') ||
                      form.attorney_type.includes('CDL')
                  "
                >
                  <div class="col-span-6 sm:col-span-2">
                    <text-input
                      label="Pay-To City"
                      :required="true"
                      id="pay_city"
                      :class="{ 'border-red-400': v$.form.pay_city.$error }"
                      v-bind:value="form.pay_city"
                      v-on:keyup="form.pay_city = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_city.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>

                  <div class="col-span-6 sm:col-span-1">
                    <text-input
                      label="Pay-To State"
                      :required="true"
                      :class="{ 'border-red-400': v$.form.pay_state.$error }"
                      v-bind:value="form.pay_state"
                      id="pay_state"
                      v-on:keyup="form.pay_state = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_state.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>

                  <div class="col-span-6 sm:col-span-1">
                    <text-input
                      label="Pay-To Zip"
                      :required="true"
                      :class="{ 'border-red-400': v$.form.pay_zip.$error }"
                      v-bind:value="form.pay_zip"
                      id="pay_zip"
                      v-on:keyup="form.pay_zip = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_zip.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>

                  <div class="col-span-6 sm:col-span-2">
                    <text-input
                      label="Pay-To County"
                      :required="true"
                      :class="{ 'border-red-400': v$.form.pay_county.$error }"
                      v-bind:value="form.pay_county"
                      id="pay_county"
                      v-on:keyup="form.pay_county = $event.target['value']"
                    ></text-input>
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.pay_county.$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment method -->
                <div
                  class="grid grid-cols-6 gap-6 mt-4"
                  v-if="
                    form.attorney_type.includes('FAM') ||
                      form.attorney_type.includes('CDL')
                  "
                >
                  <div class="col-span-6 sm:col-span-3">
                    <label class="block text-sm font-medium text-gray-900"
                      >Payment Method?</label
                    >
                    <label
                      v-for="item in payment_options"
                      :key="item.id"
                      class="inline-flex items-center mt-3 ml-2"
                    >
                      <input
                        type="radio"
                        :value="item.id"
                        v-model="form.direct_deposite"
                        class="form-radio h-5 w-5 cobalt-text-color"
                      /><span class="ml-2 text-black-100">{{ item.name }}</span>
                    </label>
                  </div>
                </div>
                <div v-if="form.direct_deposite == 1">
                  <div
                    class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4"
                  >
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <svg
                          class="h-5 w-5 text-[#1f3341]"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div class="ml-3">
                        <div class="text-sm text-[#1f3341]">
                          <div>
                            I authorize U.S. Legal Services and/or its affiliate
                            companies to deposit payments into the bank
                            specified below. My signature below indicates that I
                            am agreeing that I am either the accountholder or
                            have the authority of the accountholder to authorize
                            direct deposits into the named account.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid-cols-6 gap-6 mt-4">
                    <div class="col-span-6 sm:col-span-2">
                      <text-input
                        label="Account Holder Name"
                        :class="{
                          'border-red-400': v$.form.account_holder.$error,
                        }"
                        v-bind:value="form.account_holder"
                        id="account_holder"
                        :required="true"
                        v-on:keyup="
                          form.account_holder = $event.target['value']
                        "
                      ></text-input>
                      <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.account_holder.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input
                        label="Bank Name"
                        :required="true"
                        :class="{ 'border-red-400': v$.form.bank_name.$error }"
                        v-bind:value="form.bank_name"
                        id="bank_name"
                        v-on:keyup="form.bank_name = $event.target['value']"
                      ></text-input>
                      <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.bank_name.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <label
                        class="block text-sm font-medium text-gray-900"
                        for="date_admitted_to_bar"
                        >Checking or Savings <span class="text-red-500">*</span>
                      </label>
                      <AutoComplete
                        class="h-10"
                        forceSelection
                        v-model="form.checking_saving"
                        :dropdown="true"
                        :suggestions="checking_saving_options"
                        @complete="
                          searchAutocomplete($event, 'checking_saving')
                        "
                        field="name"
                      />
                      <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.checking_saving
                          .$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid-cols-6 gap-6 mt-4">
                    <div class="col-span-6 sm:col-span-2">
                      <text-input
                        label="Routing #"
                        :required="true"
                        :class="{
                          'border-red-400': v$.form.routing_number.$error,
                        }"
                        v-bind:value="form.routing_number"
                        id="routing_number"
                        v-on:keyup="
                          form.routing_number = $event.target['value']
                        "
                      ></text-input>
                      <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.routing_number.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input
                        label="Account #"
                        :required="true"
                        :class="{
                          'border-red-400': v$.form.account_number.$error,
                        }"
                        v-bind:value="form.account_number"
                        id="account_number"
                        v-on:keyup="
                          form.account_number = $event.target['value']
                        "
                      ></text-input>
                      <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.account_number.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { loadGoogleMaps } from "../../utils/loadGoogleMaps";
import TextInput from "../Layout/Form/TextInput.vue"; // importing resuable input field
import InputMask from "primevue/inputmask"; // Input validation masks
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import useVuelidate from "@vuelidate/core"; // importing validation library
import { required } from "@vuelidate/validators"; // importing diffrene validation types from library.
import VueGoogleAutocomplete from "vue-google-autocomplete"; // Autocomplete dropdown library of google for address

export default {
  name: "AppDisclosure",
  setup() {
    return { v$: useVuelidate() }; //creating object to access validation object.
  },
  props: ["forms"], // To access variable passed from Parent component.
  data: function() {
    // declaring static variable for this component
    return {
      mapsLoaded: false,
      isEditing: false,
      form: this.forms,
      number_options: [
        { id: "ssn", name: "SSN" },
        { id: "ein", name: "EIN" },
      ],
      checking_saving_options: [
        { id: 0, name: "Checking" },
        { id: 1, name: "Saving" },
      ],
      errors: [],
      flag_options: [
        { id: 1, name: "Yes" },
        { id: 0, name: "No" },
      ],
      payment_options: [
        { id: 0, name: "Check" },
        { id: 1, name: "Direct Deposit" },
      ],
      sizes: ["lg", "md", "sm"],
    };
  },
  unmounted() {
    this.isEditing = false;
  },
  // use to import central level variables from store
  computed: {
    ...mapState([
      "att_user",
      "profile_data",
      "address_county",
      "tempAttData"
    ]),

    maskedSSN() {
        const ssn = this.form.ssn_number;
        const digits = ssn?.replace(/\D/g, '');
        if (!digits || digits.length < 4) return '***-**-****';
        return `***-**-${digits.slice(-4)}`;
      }
  },

  //validations
  validations() {
    //For Dynamic Validation based on Dynamic form fields
    let bank_detail_required = {};
    let complaint_detail_required = {};
    let payment_required = {};
    if (this.forms.direct_deposite == 1) {
      bank_detail_required = { required };
    } else {
      bank_detail_required = {};
    }
    if (this.form.have_complaint == 1) {
      complaint_detail_required = { required };
    } else {
      complaint_detail_required = {};
    }
    if (
      this.form.attorney_type.includes("CDL") ||
      this.form.attorney_type.includes("FAM")
    ) {
      payment_required = { required };
    } else {
      payment_required = {};
    }
    return {
      form: {
        ssn_number: { required },
        pay_to: payment_required,
        complaint_detail: complaint_detail_required,
        pay_city: payment_required,
        have_complaint: { required },
        pay_zip: payment_required,
        pay_county: payment_required,
        pay_state: payment_required,
        pay_address_1: payment_required,
        is_same_as_primary: payment_required,
        direct_deposite: {},
        pay_address_2: {},
        account_holder: bank_detail_required,
        bank_name: bank_detail_required,
        checking_saving: bank_detail_required,
        routing_number: bank_detail_required,
        account_number: bank_detail_required,
      },
    };
  },
  //importing resuable component to use in this component.
  components: {
    VueGoogleAutocomplete,
    TextInput,
    InputMask,
  },
  async created() {
    try {
      await loadGoogleMaps();
    } catch(e) { console.error('Error loading Google Maps:', e); }

    this.mapsLoaded = true;
    await this.$nextTick();
    
    if (!this.att_user?.data || this.att_user == undefined) {
      this.form.number_type = "ein";
      this.form.checking_saving = { id: 0, name: "Checking" };
      if(this.tempAttData.is_attorney_exist){
         setTimeout(() => {
              if (this.tempAttData?.addresses?.length > 0) {
                if (
                  this.tempAttData.addresses[0].address1 ==
                  this.tempAttData.pay_address_1
                ) {
                  this.form.is_same_as_primary = 1;
                } else {
                  this.form.is_same_as_primary = 0;
                }
                this.$refs.pay_address_1?.update(
                  this.tempAttData.pay_address_1
                );
              }
            }, 500);
      }
    }
    this.$store.watch(
      () => this.$store.state.profile_data,
      (value) => {
        if (value != null) {
          this.isEditing = false;
          // if attorney logged in and submitted enrollment form.
          if (this.att_user?.data && this.att_user != undefined) {
            if (
              this.profile_data.complaint_detail == null ||
              this.profile_data.complaint_detail == ""
            ) {
              this.form.have_complaint = 0;
            } else {
              this.form.have_complaint = 1;
            }
            if (typeof this.profile_data?.attorney_type == "string") {
              this.form.attorney_type = this.profile_data?.attorney_type?.split(
                ","
              );
            }
            this.form.first_name = this.profile_data?.first_name;
            this.form.complaint_detail = this.profile_data.complaint_detail;
            this.form.note = this.profile_data.note;
            this.form.id = this.profile_data?.id;
            this.form.number_type = this.profile_data.number_type;
            this.form.ssn_number = this.profile_data.social_security
            this.form.pay_to = this.profile_data.pay_to;
            this.form.direct_deposite = this.profile_data.direct_deposite;
            this.form.account_holder = this.profile_data.account_holder;
            this.form.bank_name = this.profile_data.bank_name;
            this.form.routing_number = this.profile_data.routing_number;
            this.form.account_number = this.profile_data.account_number;
            this.checking_saving_options.forEach((element) => {
              if (element.name == this.profile_data.checking_saving) {
                this.form.checking_saving = element;
              }
            });
            this.form.pay_city = this.profile_data.pay_city;
            this.form.pay_zip = this.profile_data.pay_zip;
            this.form.pay_county = this.profile_data.pay_county;
            this.form.pay_state = this.profile_data.pay_state;
            this.form.pay_address_1 = this.profile_data.pay_address_1;
            this.form.pay_address_2 = this.profile_data.pay_address_2;

            setTimeout(() => {
              if (this.profile_data?.addresses?.length > 0) {
                if (
                  this.profile_data.addresses[0].address1 ==
                  this.profile_data.pay_address_1
                ) {
                  this.form.is_same_as_primary = 1;
                } else {
                  this.form.is_same_as_primary = 0;
                }
                this.$refs.pay_address_1?.update(
                  this.profile_data.pay_address_1
                );
              }
            }, 500);
          }
        }
      }
    );
  },

  methods: {
   
    // Submit form and validate it
    submitApplication: function() {
      this.isEditing = false
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      console.log(this.form);
    },
    // If payment address is same as Primary address then filling payment address with primary address
    checkForAddress: function(event) {
      let flag = event.target.value;
      if (flag == 1) {
        this.$refs.pay_address_1?.update(this.form.addresses[0].address1);
        this.form.pay_address_1 = this.form.addresses[0].address1;
        this.form.pay_address_2 = this.form.addresses[0].address2;
        this.form.pay_city = this.form.addresses[0].city;
        this.form.pay_county = this.form.addresses[0].county;
        this.form.pay_state = this.form.addresses[0].state;
        this.form.pay_zip = this.form.addresses[0].zip;
      }
    },
    // Filter dropdown list on Dropdown based on typed value
    searchAutocomplete: function(event, field) {
      if (field == "checking_saving") {
        if (!event.query.trim().length) {
          this.checking_saving_options = [...this.checking_saving_options];
        } else {
          this.checking_saving_options = this.checking_saving_options.filter(
            (item) => {
              return item.name
                .toLowerCase()
                .startsWith(event.query.toLowerCase());
            }
          );
        }
      }
    },
    // After select address from google autocomplete
    getAddressData: function(addressData, field) {
      if (field == "address1") {
        setTimeout(() => {
          let address2 = this.$refs.pay_address_1?.autocompleteText?.split(",");
          if (addressData.street_number != undefined) {
            this.$refs.pay_address_1?.update(
              addressData.street_number + " " + addressData.route
            );
            this.form.pay_address_1 =
              addressData.street_number + " " + addressData.route;
          } else {
            this.$refs.pay_address_1?.update(addressData.route);
            this.form.pay_address_1 = addressData.route;
          }
          if (address2.length > 1) {
            if (
              addressData.locality.toLowerCase().replace(/\s+/g, "") !=
              address2[1].toLowerCase().replace(/\s+/g, "")
            ) {
              this.form.pay_address_2 = address2[1];
            } else {
              this.form.pay_address_2 = "";
            }
          }
          this.form.pay_city = addressData.locality;
          // this.form.pay_county = addressData.country;

          this.form.pay_state = addressData.administrative_area_level_1;
          this.form.pay_zip = addressData.postal_code;
          this.$store.dispatch("getAddressCounty", {
            zip: this.form.pay_zip,
            city: this.form.pay_city,
            state: this.form.pay_state,
          });
          setTimeout(() => {
            this.form.pay_county = this.address_county;
          }, 1100);
        }, 300);
      }
    },
    toggleSSN() {
      this.showSSN = !this.showSSN;
    }
  },
  
};
</script>
